import { render, staticRenderFns } from "./LanternsParallax.vue?vue&type=template&id=19ef026a"
import script from "./LanternsParallax.vue?vue&type=script&lang=js"
export * from "./LanternsParallax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports